(() => {
  const closeGroups = (except) => document.querySelectorAll('.desktop-nav .gg-nav-group[open]').forEach(group => {
    if (group !== except) group.open = false;
  });
  document.addEventListener('click', event => {
    const group = event.target.closest('.gg-nav-group');
    if (!group) closeGroups();
    else if (event.target.closest('summary')) closeGroups(group);
  });
  document.addEventListener('focusin', event => closeGroups(event.target.closest('.gg-nav-group')));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const group = event.target.closest('.gg-nav-group[open]');
    if (group) {
      event.preventDefault();
      event.stopPropagation();
      group.open = false;
      group.querySelector('summary').focus();
    }
  }, true);
  const openLinkedDetails = () => {
    if (!location.hash) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch { return; }
    if (!target) return;
    const details = target.closest('details');
    if (details) details.open = true;
    if (target.id === 'product-information') target.querySelector('details')?.setAttribute('open', '');
  };
  window.addEventListener('hashchange', openLinkedDetails);
  openLinkedDetails();
  // Content above a linked section (the planner's tools, maps) can grow after the browser's first jump, and Chrome
  // doesn't correct a smooth scroll already under way. Once the page has loaded and scrolling has come to rest,
  // re-align if the target is clearly off, unless the visitor has moved.
  const alignLinkedTarget = () => {
    if (!location.hash || performance.getEntriesByType?.('navigation')[0]?.type !== 'navigate') return;
    let target;
    try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch { return; }
    if (!target) return;
    let moved = false;
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => window.addEventListener(type, () => { moved = true; }, { once: true, passive: true }));
    const align = () => {
      if (moved || !target.isConnected) return;
      // Same resting place as the browser's own jump: the target's scroll margin plus the page's scroll padding.
      const offset = (parseFloat(getComputedStyle(target).scrollMarginTop) || 0) + (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0);
      const drift = target.getBoundingClientRect().top - offset;
      if (Math.abs(drift) > 48) window.scrollTo({ top: scrollY + drift, behavior: 'instant' });
    };
    const settle = (tries = 0, lastY = -1) => {
      if (moved || tries > 30) return;
      const y = scrollY;
      if (y !== lastY) setTimeout(() => settle(tries + 1, y), 100);
      else align();
    };
    if (document.readyState === 'complete') settle();
    else window.addEventListener('load', () => settle(), { once: true });
  };
  alignLinkedTarget();
  // The header bee flies a figure eight, leaving a dotted trail, before it opens the honey page (Shane, October 24,
  // 2026). It flies a copy above the page, so the header never clips it. New-tab clicks and reduced motion skip it.
  let beeFlying = false;
  const flyBee = (link, bee) => {
    // The eight normally crosses at the bee and reaches R above and below it. Where the header leaves less room
    // above (Duo turned sideways), the bee starts further round the left loop, up to its top, so the whole eight
    // hangs below it and stays out of the announcement bar.
    const box = bee.getBoundingClientRect(), header = link.closest('header');
    const room = box.top + box.height / 2 - Math.max(0, header ? header.getBoundingClientRect().top : 0) - box.height * 0.6 - 4;
    const N = 96, A = 50, R = 27, a0 = Math.asin(Math.max(-1, Math.min(0, room / R - 1))) / 2;
    const W = 4 * A + 80, H = 4 * R + 80, ramp = 0.6, path = [], frames = [];
    const x0 = A * Math.sin(a0), y0 = R * Math.sin(2 * a0), start = Math.tanh(3 * Math.cos(a0) / Math.hypot(Math.cos(a0), 2 * R / A * Math.cos(2 * a0)));
    let length = 0;
    for (let i = 0; i <= N; i++) {
      const t = i / N * 2 * Math.PI, a = a0 + t, x = A * Math.sin(a) - x0, y = R * Math.sin(2 * a) - y0;
      const dx = A * Math.cos(a), dy = 2 * R * Math.cos(2 * a), speed = Math.hypot(dx, dy);
      // Facing eases through zero as the bee turns, so it reads as banking round rather than flipping.
      const face = Math.max(-1, Math.min(1, Math.tanh(3 * dx / speed) / start)), depth = 1 - 0.18 * (Math.sin(a) - Math.sin(a0));
      const tilt = Math.max(-50, Math.min(50, Math.atan2(dy, Math.abs(dx)) * 180 / Math.PI)) * face * Math.min(1, t / ramp, (2 * Math.PI - t) / ramp);
      if (i) length += Math.hypot(x - path[i - 1][0], y - path[i - 1][1]);
      path.push([x, y, length]);
      frames.push({ transform: `translate(${x}px,${y}px) rotate(${tilt}deg) scale(${face * depth},${depth})` });
    }
    const stage = document.createElement('div');
    stage.setAttribute('aria-hidden', 'true');
    stage.style.cssText = `position:fixed;left:0;top:0;width:${W}px;height:${H}px;margin:0;pointer-events:none;z-index:2147483000;color:${getComputedStyle(link).color}`;
    const id = 'gg-bee-trail-' + Date.now(), d = 'M' + path.map(p => p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join('L');
    stage.innerHTML = `<svg width="${W}" height="${H}" viewBox="${-W / 2} ${-H / 2} ${W} ${H}" fill="none" style="position:absolute;inset:0;overflow:visible"><mask id="${id}" maskUnits="userSpaceOnUse" x="${-W / 2}" y="${-H / 2}" width="${W}" height="${H}"><path d="${d}" stroke="#fff" stroke-width="8" stroke-dasharray="${length} ${length}" stroke-dashoffset="${length}"/></mask><path class="gg-bee-dots" d="${d}" mask="url(#${id})" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-dasharray="0.1 5.5" opacity="0"/></svg>`;
    // A thin outline in the header's own colour keeps the bee readable as it crosses the logo and icons.
    let backdrop = link, halo = 'transparent';
    while (backdrop && /^(transparent|rgba\(.*, 0\))$/.test(halo = getComputedStyle(backdrop).backgroundColor)) backdrop = backdrop.parentElement;
    const copy = bee.cloneNode(true);
    copy.style.cssText = `position:absolute;left:${(W - box.width) / 2}px;top:${(H - box.height) / 2}px;width:${box.width}px;height:${box.height}px;margin:0;transition:none;will-change:transform;filter:drop-shadow(0 0 1px ${halo}) drop-shadow(0 0 1px ${halo})`;
    stage.append(copy);
    // From the phone menu, which closes on the tap, the bee flies out over the page from the same spot.
    document.body.append(stage);
    // Centre the stage on the bee, measured after placing it in case the body is offset.
    const placed = stage.getBoundingClientRect();
    stage.style.left = box.left + box.width / 2 - W / 2 - placed.left + 'px';
    stage.style.top = box.top + box.height / 2 - H / 2 - placed.top + 'px';
    bee.style.visibility = 'hidden';
    const timing = { duration: 1450, easing: 'cubic-bezier(.45,0,.35,1)', fill: 'forwards' };
    const wings = copy.querySelector('path');
    wings.style.cssText = 'transform-box:fill-box;transform-origin:50% 100%';
    wings.animate([{ transform: 'scaleY(1)' }, { transform: 'scaleY(.35)' }], { duration: 55, iterations: Infinity, direction: 'alternate' });
    stage.querySelector('mask path').animate(path.map(p => ({ strokeDashoffset: length - p[2] })), timing);
    stage.querySelector('.gg-bee-dots').animate([{ opacity: 0 }, { opacity: 0.55, offset: 0.08 }, { opacity: 0.55, offset: 0.72 }, { opacity: 0 }], timing);
    const finish = () => {
      stage.remove();
      bee.style.visibility = '';
      location.assign(link.href);
    };
    const flight = copy.animate(frames, timing);
    flight.onfinish = finish;
    flight.oncancel = finish;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a.gg-nav-bee'), bee = link?.querySelector('svg');
    if (!bee?.animate || event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    event.preventDefault();
    if (beeFlying) return;
    beeFlying = true;
    const prefetch = document.createElement('link');
    prefetch.rel = 'prefetch';
    prefetch.href = link.href;
    document.head.append(prefetch);
    flyBee(link, bee);
  });
  // A page restored with the Back button can return mid-flight; let the bee fly again.
  window.addEventListener('pageshow', () => { beeFlying = false; });
})();
